import type {
	CoworkingSolution,
	LocationResult,
	PropositionResult,
	ServiceOfficeMembershipResult,
	FlexOfficeResult,
} from '@alexanderathoodly/data-models'
import { useAuthQuery } from '~/queries/useauthquery'
import { hashRoomList, currentShortlistQuery } from '~/queries/user_hub'

type useShortlistStatusCheckProps =
	| {
			solution: CoworkingSolution
	  }
	| { proposition: PropositionResult }
	| { location: LocationResult }
	| { membership: ServiceOfficeMembershipResult }
	| { flexoffice: FlexOfficeResult }

/**
 * If passed props type is proposition, this hook returns props as it is with
 * alreadyRequested = false. If passed props is solution, this hook checks
 * whether or not the passed solution exsists in the user's shortlist. If it
 * exsists and its status is showing_request, this hook returns the detailed
 * solution info as solutionInShortlist with alreadyRequested = true. If it exists
 * ,but its status is not showing_request, this hook returns solutionInSHortList
 * with alreadyRequested = false. Otherwise this hook returns solution as it is
 * with alreadyRequested = false.
 **/
export const useShortlistStatusCheck = (
	props: useShortlistStatusCheckProps
): {
	alreadyRequested: boolean
	propsForShowingForm: useShortlistStatusCheckProps
} => {
	const currentShortlist = useAuthQuery(currentShortlistQuery)

	if ('location' in props) {
		return { alreadyRequested: false, propsForShowingForm: props }
	}

	if ('proposition' in props) {
		return { alreadyRequested: false, propsForShowingForm: props }
	}

	if ('membership' in props) {
		return { alreadyRequested: false, propsForShowingForm: props }
	}

	if ('flexoffice' in props) {
		return { alreadyRequested: false, propsForShowingForm: props }
	}

	const solutionInShortlist = currentShortlist.data?.propositions.find(
		(proposition) =>
			hashRoomList(proposition.rooms) == hashRoomList(props.solution.rooms)
	)

	if (solutionInShortlist) {
		if (solutionInShortlist.status == 'showing_request') {
			return {
				alreadyRequested: true,
				propsForShowingForm: { proposition: solutionInShortlist },
			}
		} else {
			return {
				alreadyRequested: false,
				propsForShowingForm: { proposition: solutionInShortlist },
			}
		}
	}
	return { alreadyRequested: false, propsForShowingForm: props }
}
